import React, { useCallback, useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { useLoader } from "../../context/LoaderContext";
import { ColDef } from "ag-grid-enterprise";
import { useNavigate } from "react-router-dom";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import ExcelIcon from "../../assets/images/ExcelExport.png";
import SearchIcon from "@mui/icons-material/Search";
import { Tooltip, IconButton, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import CloseIcon from "@mui/icons-material/Close";
import { getExcelData } from "../../api/groupsApi/groupsApi";
import { getMetaDataMapping } from "../../api/metadataMappingApi/metadatMappingApi";
import { useSnackbar } from "../Common/SnackbarContext";
import { appSettings } from "../../config/appSetting";
import CustomLoadingOverlay from "../CustomLoadingOverlay/CustomLoadingOverlay ";
import isPagePermission from "../../utils/common";
import LocalStorageUtil from "../../utils/localStorage";

interface MetadataMappingMangementProps {
  businessUnitData: any;
}

const MetadataMappingManagement: React.FC<MetadataMappingMangementProps> = ({
  businessUnitData,
}) => {
  const { setLoading } = useLoader();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [showEmptySearchMessage, setShowEmptySearchMessage] = useState(false);
  const [, setRecordsFound] = useState(0);//NOSONAR
  const pageSizeSelector = appSettings.agGridPageSizeSelector;
  const defaulPageSize = appSettings.agGridDefaulPageSize;
  const [rowData, setRowData] = useState<any[]>([]);
  const { showSnackbar } = useSnackbar();
  const gridRef = useRef<AgGridReact>(null);
  const navigation = useNavigate();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const handleConfirmDialogClose = (confirmed: boolean) => {
    setConfirmDialogOpen(false);
    if (confirmed) {
      console.log("Cancel confirmed");
    }
  };

  const Actions = (props: any) => {
    if (props.data === undefined || props.data === null) {
      return null;
    }
    const handleEditAction = () => {
      const selectedRowData = props.data;
      navigation("/createmapping", {
        state: { rowData: selectedRowData, action: "Edit" },
      });
    };

    return (
      <>
        {isPagePermission("Allow Edit", "MetaDataMapping", 713) && (
          <Tooltip title="Click to edit the field">
            <EditIcon
              className="icon-button-other"
              onClick={handleEditAction}
              style={{ padding: "0.2vh", color: "var(--aggrid-text-color)" }}
            />
          </Tooltip>
        )}
      </>
    );
  };

  const [columnDefs] = useState<ColDef[]>([
    {
      headerName: "#",
      width: 70,
      sortable: false,
      filter: false,
      resizable: false,
      colId: "rowIndex",
      valueGetter: (params) => {
        return params.node ? (params.node.rowIndex ?? 0) + 1 : 0;
      },
    },
    {
      headerName: "Group Name",
      field: "metadataGroupName",
      tooltipField: "metadataGroupName",
      width: 250,
      colId: "metadataGroupName",
      flex: 1,
      enableRowGroup: true,
      filter: true,
    },
    {
      headerName: "Field Name",
      field: "metadataItemIdGrid",
      tooltipField: "metadataItemIdGrid",
      width: 250,
      colId: "metadataItemIdGrid",
      flex: 1,
      enableRowGroup: true,
      filter: true,
    },
    {
      headerName: "Updated By",
      field: "updatedBy",
      tooltipField: "updatedBy",
      width: 270,
      flex: 1,
      colId: "updatedBy",
      enableRowGroup: true,
      filter: true,
    },
    {
      headerName: "Actions",
      field: "link",
      cellRenderer: Actions,
      lockPinned: true,
      suppressSizeToFit: true,
      width: 100,
      minWidth: 100,
      pinned: "right",
    },
  ]);

  const getData = async (metadata: any) => {
    setLoading(true);
    try {
      const response = await getMetaDataMapping(metadata);
      if (metadata && searchTerm) {
        showSnackbar(response.totalCount + " records found.");
      }
      setRowData(response.metaDataModel);
      setRecordsFound(response.metaDataModel.length);
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData(metadataMappingModel);
  }, []);

  const params: any = {
    AccountId:
      businessUnitData?.accountId || LocalStorageUtil.getItem("accountId"),
    IsSuperAdmin: 1,
    SearchText: searchTerm,
    aliasname: "MetadataMapping",
    contextName:
      businessUnitData?.contextName || LocalStorageUtil.getItem("contextName"),
    isexporttpExcel: true,
    offset: appSettings.timezone,
    pagename: "MetadataMapping",
    sortOrder: 0,
  };

  const excelData = async () => {
    try {
      const excelDataResponse = await getExcelData(params);
      const blob = new Blob([excelDataResponse], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      showSnackbar("File downloaded successfully!");
      const date = new Date();
      const formattedDate = `${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date
        .getDate()
        .toString()
        .padStart(2, "0")}-${date.getFullYear()}`;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `MetadataMapping Reports_${formattedDate}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error fetching Excel data", error);
    }
  };

  const handelCreateNew = () => {
    navigation("/createmapping");
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value) {
      console.log("Value:", value);
    }
  };
  let metadataMappingModel: any = {
    AccountId:
      businessUnitData?.accountId || LocalStorageUtil.getItem("accountId"),
    IsSuperAdmin: "1",
    SearchText: "",
    UserId: LocalStorageUtil.getItem("userId"),
    currentPage: 1,
    isexporttpExcel: false,
    noOfRecords: 25,
    pagename: "MetadataMapping",
    sortOrder: 0,
  };
  const handleSearchClick = async () => {
    if (!searchTerm) {
      setShowEmptySearchMessage(true);
      return;
    }
    let metadata: any = {
      ...metadataMappingModel,
      SearchText: searchTerm,
    };
    await getData(metadata);
    setShowEmptySearchMessage(false);
  };

  const handleCloseSearch = async () => {
    setSearchTerm("");
    setShowEmptySearchMessage(true);
    await getData(metadataMappingModel);
  };

  //Quick Filter
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current!.api.setGridOption(
      "quickFilterText",
      (document.getElementById("filter-text-box") as HTMLInputElement).value
    );
  }, []);

  return (
    <div style={{ marginLeft: "2vh", }}>
      <NavigationBar
        menuTitle="Configuration"
        title="Metadata Management"
        screenTitle="Metadata Mapping"
        text="Metadata Mapping"
      />
      <div className="searchContainer">
        <div className="searchWrapper">
          <div
            style={{
              display: "none",
              alignItems: "center",
              marginTop: "2vh",
              marginLeft: "2vh",
            }}
          >
            <input
              type="text"
              placeholder="Search By Group Names"
              value={searchTerm}
              onChange={handleSearchChange}
              className="searchInput"
              data-testid="search-input"
            />
            <button onClick={handleSearchClick} className="searchButton">
              <SearchIcon style={{ color: "#006ab6" }} />
            </button>
            {searchTerm && (
              <IconButton
                onClick={handleCloseSearch}
                style={{ padding: "0.5vh" }}
              >
                <CloseIcon style={{ color: "var(--aggrid-text-color)" }} />
              </IconButton>
            )}
          </div>
          <input
            type="text"
            id="filter-text-box"
            placeholder="Quick Filter..."
            style={{
              width: "25em",
              height: "2.5em",
              fontSize: "11px",
              paddingLeft: ".5em",
              marginBottom: ".1em",
              marginLeft: "1.5em",
            }}
            onInput={onFilterTextBoxChanged}
          />
          {showEmptySearchMessage && (
            <span className="errorMessage" style={{ marginLeft: "2vh" }}>
              Please enter text for search
            </span>
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginRight: "1.6em",
          }}
        >
          {isPagePermission("Allow Create New", "MetaDataMapping", 711) && (
            <Button
              variant="contained"
              size="small"
              className="button create-new-button"
              onClick={handelCreateNew}
            >
              Create New
            </Button>
          )}
          {isPagePermission(
            "Allow Export to Excel",
            "MetaDataMapping",
            712
          ) && (
              <Tooltip title="Click to export the grid content in excel">
                <button
                  type="button"
                  onClick={excelData}
                  style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                  aria-label="Export to Excel"
                >
                  <img
                    src={ExcelIcon}
                    alt="Excel Icon"
                    className="excel-icon"
                    style={{ marginTop: ".3em" }}
                  />
                </button>
              </Tooltip>
          )}
        </div>
      </div>
      <div className="rp-main-inner col-sm-12">
        <div className="rp-main-inner col-sm-12">
          <div
            className="ag-theme-quartz-dark"
            style={{
              height: "68vh",
              marginTop: ".7vh",
              width: "98%",
              marginLeft: "1.5vh",
            }}
          >
            <AgGridReact
              columnDefs={columnDefs}
              rowData={rowData}
              pagination={true}
              paginationPageSize={defaulPageSize}
              paginationPageSizeSelector={pageSizeSelector}
              rowGroupPanelShow="always"
              pivotPanelShow="always"
              ref={gridRef}
              headerHeight={30}
              gridOptions={{
                rowSelection: {
                  mode: "multiRow",
                  checkboxes: true,
                  headerCheckbox: true,
                  enableClickSelection: false,
                },
              }}
              loading={!rowData}
              loadingOverlayComponent={CustomLoadingOverlay}
              overlayNoRowsTemplate={
                '<span class="ag-overlay-loading-center">No rows to show</span>'
              }
            />
          </div>
        </div>
      </div>
      <ConfirmDialog
        open={confirmDialogOpen}
        onClose={handleConfirmDialogClose}
        title="Metadata Group - Update Metadata Group"
        content="Please note that the Metadata-Group is mapped with the Metadata-Field. Are you sure you want to proceed?"
      />
    </div>
  );
};

export default MetadataMappingManagement;
